export default "__VITE_ASSET__CZQhVqdm__"